import { FC } from 'react'
import { motion } from 'framer-motion'

const Philosophy: FC = () => {
  return (
    <section className="py-20 lg:py-32 bg-off-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <span className="section-tag">Our Philosophy</span>
            <h2 className="section-heading">Because We Care</h2>
            
            <blockquote className="relative">
              <div className="absolute -top-4 -left-4 text-6xl text-primary/20 font-serif">
                "
              </div>
              <p className="text-lg sm:text-xl text-text-gray leading-relaxed relative z-10 italic">
                At Studio Figura Larnaca, we believe true beauty radiates from within. Let us guide your journey to confidence with personalized treatments that help you become the radiant person you deserve to be.
              </p>
            </blockquote>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="order-1 lg:order-2"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/assets/piec_krokow_wywiad2.webp"
                alt="Consultation Process"
                className="w-full h-auto object-cover"
              />
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary/10 rounded-full -z-10" />
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/5 rounded-full -z-10" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Philosophy
